import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Typography,
} from "@mui/material";
import React from "react";
import { Control, Controller, FieldErrors, Path } from "react-hook-form";
import { ClientDetailsInput } from "@/types/bookingTypes";

type MarketingConsentProps<Schema> = {
  name: Path<Schema>;
  control: Control<Schema>;
  errors: FieldErrors<ClientDetailsInput>;
};

function MarketingConsent<S>({
  control,
  errors,
  name,
}: MarketingConsentProps<S>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value as boolean}
                sx={{
                  alignSelf: "flex-start",
                }}
              />
            }
            label={
              <Typography
                variant="labelDefault"
                sx={{
                  color: "secondary.main",
                  mt: 1,
                }}
              >
                I agree to receive transactional messages related to my
                appointment at the phone number above. I understand I will
                receive periodic messages, data rates may apply, reply STOP to
                opt out.
              </Typography>
            }
          />

          {errors.marketingConsent && (
            <FormHelperText error={!!errors.marketingConsent}>
              {errors.marketingConsent?.message ?? ""}
            </FormHelperText>
          )}
        </>
      )}
    />
  );
}

export default MarketingConsent;
